import {
  createContext, useContext,
} from 'react'

/**
 * The Apps page's search text, read by every app tile in the catalog so one
 * box filters the hard-coded, featured and promoted tiles alike. Empty (the
 * default, and every other surface) shows everything.
 */
export const AppTileFilter = createContext('')

/** Attribute every app tile carries, so a category card can hide itself when none matched. */
export const APP_TILE_ATTRIBUTE = { 'data-app-tile': '' } as const

/** The current search, trimmed and lowercased; '' when there is none. */
export function useAppQuery(): string {
  return useContext(AppTileFilter).trim().toLowerCase()
}

/** Whether a tile named `name` survives the current search. */
export function useAppTileVisible(name: string): boolean {
  const query = useAppQuery()
  return query === '' || name.toLowerCase().includes(query)
}

/** The class that hides a category card during a search that left it no tile. */
export function useHideWhenNoTiles(): string {
  return useAppQuery() === '' ? '' : '[&:not(:has([data-app-tile]))]:hidden'
}
